import { combineReducers } from "redux";
import { notificationUiData } from "./reducer";

export default combineReducers({
  notificationUiData
});
